import { put, takeLatest, fork, call } from "redux-saga/effects";
import {
  ClassListData,
  ActionType,
  IClassListResponse,
} from "models/mentalHealth/classList";
import { httpStatus } from "configs/httpStatus";
import { getClassList } from "services/mentalHealth";
import { handleSuccesAction, handleErrorAction } from "./classListActions";

function* classListSaga({ payload }: { payload: ClassListData }) {
  try {
    const response: IClassListResponse = yield call(getClassList, payload);
    if (response.status === httpStatus.StatusOK) {
      yield put(handleSuccesAction(response));
    } else {
      yield put(handleErrorAction(response.message || ""));
    }
  } catch (error) {
    yield put(handleErrorAction("error"));
  }
}
function* onGetClassListWatcher() {
  yield takeLatest(ActionType.MENTAL_CLASS_LIST as any, classListSaga);
}

export default [fork(onGetClassListWatcher)];
